import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KeycloakGuard } from '@badgertechnologies/liblogin.js';
import { roleGuardFn } from '@ng-cloud/badger-core';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
    canActivate: [KeycloakGuard]
  },
  {
    path: 'robots',
    loadChildren: () => import('./robot/robot.routes').then(m => m.ROBOT_ROUTES),
    data: { roles: ['installer', 'user', 'verifier', 'depot', 'skybox_level_1'] },
    canMatch: [roleGuardFn]
  },
  {
    path: 'stores',
    loadChildren: () => import('./store/store.routes').then(m => m.STORE_ROUTES),
    data: { roles: ['user', 'skybox_level_1'] },
    canMatch: [roleGuardFn]
  },
  {
    path: 'skybox',
    loadChildren: () => import('./skybox/skybox.routes').then(m => m.SKYBOX_ROUTES),
    data: { roles: ['phone_support', 'skybox_level_1', 'robot_escalation_supervisor'] },
    canMatch: [roleGuardFn]
  },
  {
    path: 'organizations',
    loadChildren: () => import('./organization/organization.routes').then(m => m.ORGANIZATION_ROUTES),
    data: { roles: ['user'] },
    canMatch: [roleGuardFn]
  },
  {
    path: 'verification', loadChildren: () => import('./verification/verification.routes').then(m => m.VERIFICATION_ROUTES),
    data: { roles: ['verifier', 'depot'] },
    canMatch: [roleGuardFn]
  },
  {
    path: 'users', loadChildren: () => import('./user/user.routes').then(m => m.USER_ROUTES)
  },
  { path: 'restricted', redirectTo: '/' },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })]
})
export class AppRoutingModule {
}
